import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16037b14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "MajorPageBackground" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { id: "headerMainContainer" }
const _hoisted_4 = { id: "headerLine1" }
const _hoisted_5 = { id: "majorName" }
const _hoisted_6 = { id: "headerLine2" }
const _hoisted_7 = { id: "mainBody" }

import {ref, reactive} from 'vue';
  import {ElMessage} from 'element-plus';

  import  ProfessionSituation from './ProfessionSituation.vue'
  import  MatchMajor from './MatchMajor.vue'
  import {
    getOccInfo,
    majorsGetMajorsDetailV2,
    masterGetCollegeName
  } from "@/network/axios";
  import {useRouter, useRoute} from "vue-router";


  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProfessionPage',
  setup(__props) {

  let router = useRouter();
  let route = useRoute();


  // ==============================================//
  let occId =route.params.occId;
  //检查 机型
  let _isMobile = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
  };
  //如果是手机 就跳转手机页面
  if (_isMobile()) {
    router.push('/MobileProfessionPage/'+occId)
  }

  //==========专业概况 硕士专业 tab===========
  let activeName = ref('职业概况')
  let isProfessionSituation = ref(true)
  let isMatchMajor = ref(false)
  let handleClick = (tab: any) => {
    if (tab.paneName == '职业概况') {
      isProfessionSituation.value = true;
      isMatchMajor.value = false;
    } else if (tab.paneName == '匹配专业') {
      isProfessionSituation.value = false;
      isMatchMajor.value = true;
    }
  }
  // ==============================================//

  //页面数据
  let professionInfo = reactive({
    //第一行专业名称
    occName: '',
    //第二行 行业 职业类别 岗位薪资
    line2Str: '',

    //
    definition: '',
    //
    developmentSpace: '',


    //
    jobRequire: '',
    //
    occIntroduction: '',
    occTrait: '',

    //
    workContact: '',

  });
  let getProfessionMethod = () => {
    getOccInfo('/getOccInfo', {
      params: {
        occId: route.params.occId,
      }
    }).then((res) => {
      if (res.data.code == '200') {
        Object.assign(professionInfo,res.data.data)
        let line2Array: any = ref([]);
        if (res.data.data.industry != '') {
          line2Array.value.push('行业:' + res.data.data.industry);
        }
        if (res.data.data.occType != '') {
          line2Array.value.push('职业类别:' + res.data.data.occType);
        }
        if (res.data.data.positionSalary != '') {
          line2Array.value.push('岗位薪资:' + res.data.data.positionSalary);
        }
        professionInfo.line2Str = line2Array.value.join(' | ');

      }
    })
  };

  getProfessionMethod()


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(professionInfo).occName), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(professionInfo).line2Str), 1)
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: _unref(activeName),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : activeName = $event)),
        class: "bigElTabs",
        onTabClick: _unref(handleClick)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "职业概况",
            name: "职业概况"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "匹配专业",
            name: "匹配专业"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_unref(isProfessionSituation))
        ? (_openBlock(), _createBlock(ProfessionSituation, {
            key: 0,
            professionInfo: _unref(professionInfo)
          }, null, 8, ["professionInfo"]))
        : _createCommentVNode("", true),
      (_unref(isMatchMajor))
        ? (_openBlock(), _createBlock(MatchMajor, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})